import React, { useEffect, useState } from 'react'
import { View, Alert, Platform } from 'react-native'
import { ScrollView } from 'react-native-gesture-handler'
import { useDispatch } from 'react-redux'
import tw from 'tailwind-rn'
import { RouteProp } from '@react-navigation/native'

import { StackNavigationProp } from '@react-navigation/stack'
import { BlockGrid } from '../../components/Content'
import { HGButton, HGView } from '../../components/HGUI'
import { ResourceType } from '../../config/types'
import { RootStackParamList } from '../../navigators/AppNavigator'
import WebAlert from '../../components/HGModal/Alert.web'
import ActionCreators from '../../store/actions'

type Props = {
  navigation: StackNavigationProp<RootStackParamList>
  route: RouteProp<RootStackParamList, 'GenericResource'>
}

const GenericResourceScreen = (props: Props) => {
  const {
    navigation,
    route: {
      params: { resourceId },
    },
  } = props
  const [loading, setLoading] = useState<boolean>(false)
  const [webAlertVisible, setWebAlertVisible] = useState<boolean>(false)
  const [resource, setResource] = useState<ResourceType | null>(null)
  const dispatch = useDispatch()
  const isDocumentable = resource?.isDocumentable || false

  useEffect(() => {
    setLoading(true)
    dispatch(ActionCreators.loadResource({ resourceId }))
      .then((result) => {
        navigation.setOptions({ title: result.title })

        setResource({
          ...result,
          isDocumentable: result.is_documentable,
        })
      })
      .catch()
      .then(() => setLoading(false))
  }, [])

  const _handleButtonPress = () => {
    if (Platform.OS !== 'web') {
      Alert.alert(
        'Sind Ihnen die rechtlichen Grundlagen bekannt?',
        `
          Bei Verdacht auf Kindeswohlgefährdung ist eine Untersuchung nur statthaft:
    
          - bei richterlicher, staatsanwaltlicher oder polizeilicher Anordnung
          - nach Zustimmung aller Sorgeberechtigten
          - nach Inobhutnahme durch das Jugendamt
    
          Eine Untersuchung bei akuten Notfällen bzw. organischen oder psychischen Erkrankungen bleibt davon unberührt.
          `,
        [
          // { text: 'Mehr Informationen' },
          { text: 'Abbrechen', style: 'cancel' },
          {
            text: 'Jetzt dokumentieren',
            onPress: () => navigation.navigate('Documentation'),
          },
        ]
      )
    } else {
      // setWebAlertVisible(true)
      navigation.navigate('Documentation')
    }
  }

  return (
    <ScrollView style={tw('relative')}>
      <HGView>
        <View
          style={tw(
            ['pt-6', 'px-3', ...(isDocumentable ? ['pb-24'] : [])].join(' ')
          )}
        >
          <BlockGrid blocks={resource?.blocks || null} />
        </View>

        {isDocumentable && (
          <View
            style={[
              tw('absolute bottom-0 w-full'),
              Platform.OS === 'web' ? { position: 'sticky' } : [],
            ]}
          >
            <WebAlert
              title="Titel"
              content="Irure ullamco cillum nisi et. Labore voluptate in labore mollit nostrud veniam in velit est irure consequat dolor. Lorem consequat nostrud ex occaecat in ullamco laborum enim in fugiat Lorem ipsum nisi. Eu aliquip eiusmod culpa laborum non fugiat et. Do aliqua mollit mollit mollit cupidatat sint minim esse."
              visible={webAlertVisible}
              onClose={() => setWebAlertVisible(false)}
            />

            <View style={{ backgroundColor: `rgba(243, 241, 238, 0.5)` }}>
              <View style={tw('p-6 items-center')}>
                <HGButton
                  title="Jetzt dokumentieren"
                  onPress={() => _handleButtonPress()}
                  style={tw('w-full')}
                />
              </View>
            </View>
          </View>
        )}
      </HGView>
    </ScrollView>
  )
}

export default GenericResourceScreen
